import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "";

/**
 * @param {{ north: number, south: number, east: number, west: number }} bounds
 * @param {number} zoom
 * @param {{ mode?: 'detail'|'overview', minSpanM?: number }} [options]
 * @returns {Promise<{ points: object[], truncated: boolean, limit: number }>}
 */
export async function fetchDepthPoints(bounds, zoom, options = {}) {
    const params = {
        north: bounds.north,
        south: bounds.south,
        east: bounds.east,
        west: bounds.west,
        zoom,
    };
    if (options.mode) {
        params.mode = options.mode;
    }
    if (Number.isFinite(options.minSpanM)) {
        params.min_span_m = options.minSpanM;
    }

    const { data } = await axios.get(`${API_BASE}/api/depth`, {
        params,
        withCredentials: true,
    });

    if (Array.isArray(data)) {
        return {
            points: data,
            truncated: data.length >= 5000,
            limit: 5000,
        };
    }

    const points = Array.isArray(data?.points) ? data.points : [];
    return {
        points,
        truncated: Boolean(data?.truncated),
        limit: Number(data?.limit) > 0 ? Number(data.limit) : 5000,
    };
}
